<template>
  <!-- 灰度测试 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <el-form-item :label="$t('omission.text21')">
          <el-select
            v-model="searchParams.status"
            :placeholder="$t('public.text5')"
            clearable
          >
            <el-option :label="$t('omission.text18')" value="0"> </el-option>
            <el-option :label="$t('omission.text19')" value="1"> </el-option>
            <el-option :label="$t('omission.text20')" value="2"> </el-option>
            <el-option :label="$t('omission.text50')" value="3"> </el-option>
          </el-select>
        </el-form-item>
        <!-- 固件类别 -->
        <el-form-item :label="$t('pages.equipment.text198')">
          <el-select
            v-model="searchParams.hwType"
            :placeholder="$t('public.text5')"
            clearable
          >
            <el-option
              v-for="item in opeting"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text5')">
          <el-select
            v-model="searchParams.bikeCategoryId"
            :placeholder="$t('public.text5')"
            clearable
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text6')">
          <el-select
            v-model="searchParams.bikeTypeId"
            :placeholder="$t('public.text5')"
            clearable
          >
            <el-option
              v-for="(item, index) in option"
              :key="index"
              :label="item.bikeTypeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text212')" label-width="auto">
          <el-date-picker
            v-model="searchParams.startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            :picker-options="pickerOptions0"
            @change="startChange"
            class="date_picker"
          >
          </el-date-picker>
          <span style="margin: 0 14px">-</span>
          <el-date-picker
            v-model="searchParams.stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
            class="date_picker"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton
          type="search"
          @click="search"
          v-permission="['grayScaleTest:query']"
        ></DiluButton>
        <DiluButton
          type="reset"
          @click="reset"
          v-permission="['grayScaleTest:reset']"
        ></DiluButton>
      </div>
    </div>

    <!-- 按钮区域 -->
    <div class="operation">
      <DiluButton
        type="add"
        buttonType="primary"
        :title="$t('button.grayscaleConfig')"
        @click="add"
        v-permission="['grayScaleTest:grayscaleConfig']"
      ></DiluButton>
    </div>

    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
      :total="total"
    >
      <el-table-column prop="id" label="ID" width="100" align="center"/>
      <el-table-column
        prop="startValidTime"
        :label="$t('pages.equipment.text212')"
        width="180"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="status"
        :label="$t('omission.text21')"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <!-- 状态 0已发布 1灰度中 2 已取消 3已完成 -->
            <span v-if="scope.row.status == 0">{{
              $t("omission.text18")
            }}</span>
            <span v-if="scope.row.status == 1">{{
              $t("omission.text19")
            }}</span>
            <span v-if="scope.row.status == 2">{{
              $t("omission.text20")
            }}</span>
            <span v-if="scope.row.status == 3">{{
              $t("omission.text50")
            }}</span>
          </div>
        </template>
      </el-table-column>
      <!-- 固件类别 -->
      <el-table-column
        prop="hwType"
        :label="$t('pages.equipment.text198')"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-for="(item, index) in opeting" :key="index">
              {{ item.value == scope.row.hwType ? item.label : "" }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="hwVersion" :label="$t('omission.text71')" align="center" width="180" />
      <el-table-column prop="fwVersion" :label="$t('omission.text72')" align="center" width="180" />
      <el-table-column
        prop="bikeCategoryName"
        :label="$t('pages.equipment.text5')"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="upgradePer"
        :label="$t('pages.equipment.text195')"
        align="center"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.upgradePer }}%</div>
        </template>
      </el-table-column>

      <el-table-column
        prop="bikeTypeName"
        :label="$t('pages.equipment.text6')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="bikeNum"
        :label="$t('pages.equipment.text213')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{ $t("public.text4")
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="{ type: 'see', data: scope.row }"
                  v-permission="['grayScaleTest:see']"
                  >{{ $t("button.look") }}</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'updata', data: scope.row }"
                  v-permission="['grayScaleTest:upgrade']"
                  :disabled="scope.row.status != 3"
                  >{{ $t("button.upgradeRelease") }}</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'cancel', data: scope.row }"
                  :disabled="!scope.row.cancelFlag"
                  >{{ $t("omission.text15") }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 灰度配置弹窗 -->
    <GrayScaleTestAdd
      @dialogClose="dialogClose"
      :dialogVisible="dialogVisible"
      :bikeCategoryIdList="bikeCategoryIdList"
      @grayScaleTestList="grayScaleTestList"
    />

    <!-- 升级发布弹窗 -->
    <ReleaseUpdate
      @releaseClose="releaseClose"
      :releaseVisible="releaseVisible"
      :currentUpdata="currentUpdata"
      @grayScaleTestList="grayScaleTestList"
    />
  </div>
</template>


<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import ReleaseUpdate from "./module/releaseUpdate";
import GrayScaleTestAdd from "./module/grayScaleTestAdd.vue";
import { resetDate } from "../../../utils/util/validate";
import { mapState } from "vuex";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      currentUpdata: null, //升级
      searchParams: {
        hwType: "", //固件类别
        belongCustomerId: "",
        bikeCategoryId: "", //车辆类别id
        bikeTypeId: "", //车辆型号id
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        startAt: "", //查询开始时间
        stopAt: "", //查询结束时间
        taskType: "0",
        status: "",
      },
      releaseVisible: false, //升级发布弹窗
      dialogVisible: false, //新增编辑弹窗
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      opeting: [
        {
          value: 10,
          label: this.$t("pages.equipment.text178"), //蓝牙
        },
        {
          value: 15,
          label: this.$t("pages.equipment.text202"), //电机控制器
        },
        {
          value: 20,
          label: this.$t("pages.equipment.text203"), //仪表
        },
        {
          value: 25,
          label: this.$t("pages.equipment.text204"), //电池
        },
        {
          value: 30,
          label: this.$t("pages.equipment.text205"), //中央控制器
        },
        {
          value: 35,
          label: this.$t("pages.equipment.text206"), //钢缆锁
        },
        {
          value: 40,
          label: this.$t("pages.equipment.text207"), //电池锁
        },
        {
          value: 45,
          label: this.$t("pages.equipment.text208"), //轮毂锁
        },
      ],
      total: 0,
      options: [],
      option: [],
      tableData: [],
      bikeCategoryIdList: [],
      isSerch: false, //是否在查询
    };
  },
  components: {
    DiluTable,
    DiluButton,
    ReleaseUpdate,
    GrayScaleTestAdd,
  },
  mounted() {
    this.grayScaleTestList();
    this.equipmentModeListAll();
    this.firmwareManagementListAllCategory();
  },
  computed: {
    ...mapState(["platformData"]),
  },
  methods: {
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.grayScaleTestList();
    },
    //操作
    handleCommand(e) {
      if (e.type == "see") {
        this.see(e.data);
      }
      if (e.type == "updata") {
        this.updata(e.data);
      }
      if (e.type == "cancel") {
        this.cancel(e.data);
      }
    },
    //取消灰度
    cancel(e) {
      let that = this;
      this.$confirm(that.$t("omission.text16"), this.$t("public.text6"), {
        confirmButtonText: this.$t("button.determine"),
        cancelButtonText: this.$t("button.cancel"),
        type: "warning",
      })
        .then(() => {
          that.request.grayScaleTestCancelGrayTask({ id: e.id }).then(() => {
            that.$message({
              message: that.$t("omission.text17"),
              type: "success",
            });
            that.grayScaleTestList();
          });
        })
        .catch();
    },
    startChange() {
      this.searchParams.stopAt = null;
    },
    //获取灰度测试列表
    grayScaleTestList() {
      this.searchParams.belongCustomerId = this.platformData.id;
      if (this.searchParams.stopAt && this.searchParams.startAt) {
        this.searchParams.stopAt = resetDate(this.searchParams.stopAt); // 结束时间
        this.searchParams.startAt = resetDate(this.searchParams.startAt); // 开始时间
      }
      if (this.searchParams.startAt) {
        if (!this.searchParams.stopAt) {
          return this.$message.error(this.$t("public.text3"));
        }
      }
      if (this.searchParams.stopAt) {
        if (!this.searchParams.startAt) {
          return this.$message.error(this.$t("public.text2"));
        }
      }
      this.request.grayScaleTestList(this.searchParams).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
    //车辆型号-查询所有
    equipmentModeListAll() {
      this.request.equipmentModeListAll().then((res) => {
        this.option = res.data;
      });
    },
    //车辆类别-查询所有
    firmwareManagementListAllCategory() {
      this.request.firmwareManagementListAllCategory().then((res) => {
        this.options = res.data;
      });
    },
    //重置
    reset() {
      this.isSerch = false; //是否在查询
      this.searchParams = {
        bikeCategoryId: "", //车辆类别id
        bikeTypeId: "", //车辆型号id
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        startAt: "", //查询开始时间
        stopAt: "", //查询结束时间
        taskType: "0",
        status: "",
      };
      this.total = 0;
      this.grayScaleTestList();
    },
    //翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams = {
          bikeCategoryId: "", //车辆类别id
          bikeTypeId: "", //车辆型号id
          pageNum: 1, //页码
          pageSize: 10, //每页条数
          startAt: "", //查询开始时间
          stopAt: "", //查询结束时间
          taskType: "0",
          status: "",
        };
      }
      this.searchParams.pageNum = e;
      this.grayScaleTestList();
    },
    //关闭新增编辑弹窗
    dialogClose() {
      this.dialogVisible = false;
    },

    see(e) {
      console.log(e);
      this.$router.push({
        path: "/equipment/firmwareUpdate/grayScaleTestInfo",
        query: {
          id: e.id,
          taskType: "0",
          upgradeType: e.upgradeType,
        },
      });
    },
    //升级发布
    updata(e) {
      this.currentUpdata = e;
      this.releaseVisible = true;
    },
    //关闭升级发布弹窗
    releaseClose() {
      this.releaseVisible = false;
    },
    //灰度配置
    add() {
      this.request.firmwareManagementListAllCategory().then((res) => {
        this.bikeCategoryIdList = res.data;
        this.dialogVisible = true;
      });
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
</style>